module.exports = __webpack_public_path__ + "f1cf71c16d8f2514003547a6fd7e22e8.svg";